import { render, staticRenderFns } from "./listWelfare.vue?vue&type=template&id=62fdf446&scoped=true"
import script from "./listWelfare.vue?vue&type=script&lang=js"
export * from "./listWelfare.vue?vue&type=script&lang=js"
import style0 from "./listWelfare.vue?vue&type=style&index=0&id=62fdf446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fdf446",
  null
  
)

export default component.exports